import { defineComponent as _defineComponent } from 'vue'
import { usePagination } from './pagination'
import { computed, reactive, ref, toRef } from 'vue'
import { useBuildSearchClientsQuery } from '@/components/companies/query'
import { useSearchClientsQuery } from '@/api/connection-request'
import ConnectionRequestConfirmationDialog from '@/components/companies/ConnectionRequestConfirmationDialog.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import VsPagination from '@/components/vision/VsPagination.vue'
import { Client, ConnectionStatus } from '@/models/client'
import { useStore } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientsList',
  props: {
    creatingConnection: { type: Boolean },
    search: null
  },
  emits: ["select", "open-create-client-form"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'select', hubId: string)
  (e: 'open-create-client-form')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  creatingConnection: boolean
  search: string
}



const store = useStore()
const canCreateClient = computed<boolean>(
  () => store.getters['permissions/canCreateClient']
)
const { currentPage, updatePage } = usePagination()
const query = reactive(
  useBuildSearchClientsQuery(currentPage, 20, toRef(props, 'search'))
)
const isSearchResultsEmpty = computed(() => {
  return (clients.value?.length ?? 0) === 0
})
const { clients, totalPages, isLoading } = useSearchClientsQuery(query)

const showConfirmationDialog = ref<boolean>()
const selectedHub = ref<Client>()



function handleSelectHub(selectedHubId: string) {
  if (!canCreateClient.value) {
    return
  }
  selectedHub.value = clients.value?.find((c) => c.id === selectedHubId)
  showConfirmationDialog.value = true
}

function handleSendConnection() {
  showConfirmationDialog.value = false
  if (!selectedHub.value) {
    return
  }

  emit('select', selectedHub.value.id)
}

function getStatusChipText(connectionStatus, canManageConnections) {
  if (connectionStatus === ConnectionStatus.Pending) {
    return 'Pending'
  }

  if (connectionStatus === ConnectionStatus.Rejected) {
    return 'Rejected'
  }

  if (connectionStatus === ConnectionStatus.Accepted) {
    return 'Connected'
  }

  if (canManageConnections) {
    return 'Invite'
  }

  return 'Connect'
}

const handleOpenCreateClientForm = () => {
  emit('open-create-client-form')
}

expose({ updatePage })

return { __sfc: true,props, store, canCreateClient, currentPage, updatePage, query, isSearchResultsEmpty, clients, totalPages, isLoading, showConfirmationDialog, selectedHub, emit, handleSelectHub, handleSendConnection, getStatusChipText, handleOpenCreateClientForm, ConnectionRequestConfirmationDialog, VsButton, VsText, VsPagination, ConnectionStatus }
}

})